export const containsEmoji = (value: string) => /\p{Extended_Pictographic}/u.test(value);
